<template>
  <a-modal
    v-model="visible"
    :title="title"
    :width="1000"
    :footer="null"
    destroyOnClose
    class="feedback-detail-modal"
  >
    <TableList
      style="width: 100%; margin-top: 5px"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
      :pagination="ipagination"
      @change="handleTableChange"
    />
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableList from '@comp/chart/TableList.vue'
import { formatYearMonthDate } from '@/utils/date'

export default {
  name: 'FeedbackDetailModal',
  mixins: [JeecgListMixin],
  components: {
    TableList,
  },
  data() {
    return {
      visible: false,
      disableMixinCreated: true,
      currentTabKey: 1,
      url: {
        list: '/statisticV2/getFeedbackStudentListDetails',
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          customRender: (_, record, index) => index + 1,
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '班主任',
          dataIndex: 'headTeacherName',
          align: 'center',
        },
        {
          title: '反馈原因',
          dataIndex: 'reason',
          align: 'center',
        },
        {
          title: '反馈时间',
          dataIndex: 'feedbackTime',
          align: 'center',
        },
      ],
    }
  },
  computed: {
    title() {
      const tabMap = {
        1: '有底图未采集',
        2: '未录入人脸',
        3: '活跃度低',
      }
      return tabMap[this.currentTabKey]
    },
  },
  watch: {
    // currentTabKey为1
    currentTabKey: {
      handler(val) {
        const isHas = this.columns.some((item) => item.dataIndex === 'notCollectTime')
        if (val == 1 && !isHas) {
          this.columns.splice(4, 0, {
            title: '未采集时间',
            dataIndex: 'notCollectTime',
            align: 'center',
          })
          return
        }
        if (isHas) {
          this.columns.splice(4, 1)
        }
      },
      immediate: true,
    },
  },
  methods: {
    showModal(record, tabKey, dateRange = []) {
      this.currentTabKey = tabKey
      this.dataSource = []
      this.queryParam = {
        type: tabKey,
        studentId: record.studentId,
        beginDate: dateRange?.[0] ? formatYearMonthDate(dateRange[0]) : undefined,
        endDate: dateRange?.[1] ? formatYearMonthDate(dateRange[1]) : undefined,
      }
      this.visible = true
      this.loadData(1)
    },
    hideModal() {
      this.visible = false
    },
  },
}
</script>

<style scoped lang="less">
.feedback-detail-modal {
  /deep/ .ant-modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  /deep/ .ant-modal-body {
    min-height: 450px;
    padding: 10px 24px;
  }
}
</style>
